import { baseTheme } from "./base";

/**
 * App theme based on device settings (Appearance API)
 * - default is the light theme
 */
export const theme = { ...baseTheme };
